import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function pairwise() {
    return function (source) {
        return new Observable(function (subscriber) {
            var prev;
            var hasPrev = false;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                var p = prev;
                prev = value;
                hasPrev && subscriber.next([p, value]);
                hasPrev = true;
            }));
        });
    };
}
//# sourceMappingURL=pairwise.js.map